import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as QuestionMarkIcon } from "../../../../../../assets/img/svg/QuestionMarkConfirmationDialog.svg";
import { ReactComponent as CrossIcon } from "../../../../../../assets/img/svg/CrossIcon.svg";
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { selectStyles } from '../../scholarshipMaster/exAakashianConfig/common';
import { failureToast } from '../../../common/utils/methods/toasterFunctions/function';
import moment from 'moment';

const ConfirmRejectionDialog = ({ updateStatusInfo, setUpdateStatusInfo, updateStatus, dialogInfo = {}, customStyle = {} }) => {


    const [remark, setRemarks] = useState('');
    const [selectedReason, setSelectedReason] = useState()
    const { isUpdatedDetailRequired, updatedBy, updatedOn } = updateStatusInfo || {};
    const updatedOnDate = updatedOn ? moment(updatedOn).format('DD/MM/YYYY') : '';
    const updatedOnTime = updatedOn ? moment(updatedOn).format('hh:mm A') : '';

    const closeDialog = () => {
    setSelectedReason('');
    setRemarks('');
    setUpdateStatusInfo(null);
};

    const disabled = (updateStatusInfo?.dropdown && !selectedReason) || (updateStatusInfo?.isRemarkMandatory && !remark);
    const {
        heading = "Are you sure you want to reject?",
        subHeading = "Please enter a reason for rejection",
        proceedBtn = (
            <button
                disabled={disabled}
                className={`reject-btn ${disabled ? 'reject-btn--disabled' : ''}`}
                style={
                    disabled
                        ? { backgroundColor: '#e0e0e0', color: '#9e9e9e', cursor: 'not-allowed' }
                        : undefined
                }
            >
                Yes, reject
            </button>
        ),
        remarksMandatory = false,
    } = dialogInfo || {};
    const finalProceedBtn = React.cloneElement(
        proceedBtn,
        {
            disabled,
            style: disabled
                ? { backgroundColor: '#e0e0e0', color: '#9e9e9e', cursor: 'not-allowed' }
                : proceedBtn.props.style
        }
    );

    const proceedHandler = () => {
        try {
            if(remarksMandatory && !remark){
                failureToast("Please enter remarks!");
                return;
            }
            closeDialog();
            updateStatus({ ...updateStatusInfo, remark, selectedReason });
            
        } catch (err) {
            console.error(err);
        }
    }
useEffect(() => {
    if (updateStatusInfo) {
        // Dialog opened → reset fields
        setRemarks('');
        setSelectedReason('');
    }
}, [updateStatusInfo]);


    return (
        <Dialog
            open={!!updateStatusInfo}
        //  fullWidth
        // size="md"
        >
            <div className='p-4 confirm-rejection-dialog' style={{ maxWidth: customStyle?.maxWidth }}>
                <div className='d-flex justify-content-between'>
                    <QuestionMarkIcon />
                    <CrossIcon onClick={closeDialog} />

                </div>

                <div className='header'>{heading}</div>
                <div className='subHeading'>{subHeading}</div>

                <div className='remarks-wrapper' style={updateStatusInfo?.dropdown && { height: '151px' }}>
                    {updateStatusInfo?.dropdown && <AAutoComplete
                        label='Reason for rejection'
                        items={updateStatusInfo?.dropdown}
                        currentValue={selectedReason}
                        isMulti={false}
                        handleChange={val => setSelectedReason(val)}
                        style={selectStyles}
                    />}
                    <div className={`${updateStatusInfo?.dropdown && 'mt-2'}`}>Remarks{remarksMandatory ? "*" : ""}</div>
                    <textarea
                        placeholder='Add a comment..'
                        value={remark}
                        onChange={(e) => setRemarks(e.target.value)}
                    />
                </div>

                <div className='mt-4' style={{display:'flex'}}>
                    <button className='no-ml-btn' onClick={closeDialog}>Go back</button>
                    <span onClick={proceedHandler}>{finalProceedBtn}</span>
                </div>
                {isUpdatedDetailRequired&&<div className='color-grey-50 regular-small mt-2'> Last updated by {updatedBy}  on {updatedOnDate} at {updatedOnTime}</div>}

            </div>



        </Dialog>
    );
}

export default ConfirmRejectionDialog;